<template>
  <section class="screen">
     <div class="exit-btn" @click="exitLesson">  <img src="@/assets/icons/menu/windows_control/Close_1.svg" alt /></div>
    <iframe
      id="captivate"
      ref="lesson"
      class="lesson"
      :src="'https://' + hostname + '/static/lessons/' + currentLesson.path.find(item => item.lang === lang).value"
      frameborder="0"
      allowfullscreen
      allow="autoplay; fullscreen"
      @load="onLoad"
    ></iframe>
    <!-- <div v-if="showCountDown" class="count-down">
      <label class="seconds">{{ secondsDown }}</label>
    </div> -->
    <div v-if="shadow" class="shadow">
      <button type="button" class="btn btn-skip btn-success" @click.once="skip">
        {{ $t('testTest.continue') }}
      </button>
    </div>
    <!-- <div class="shadow">
      <button type="button" class="btn btn-success" @click.once="skip">
        {{ $t('testTest.skip') }}
      </button>
    </div> -->
    <!-- <button class="btn worksheets-btn" @click="serveWorkSheet">Worksheetssss</button> -->
   
    <el-dialog
      v-loading="loading"
      title="Worksheets"
      :visible.sync="dialogVisible"
      top="3vh"
      width="90%"
      :before-close="handleClose"
    >
      <div class="row">
        <template v-if="listUrlWorksheet.length === 0">
          <div class="col-12">
            <h1 class="mt-5 text-center">{{ $t('worksheets.notFound') }}</h1>
          </div>
        </template>
        <template v-else>
          <div
            v-for="link in listUrlWorksheet"
            :key="link"
            :class="listUrlWorksheet.length === 1 ? 'col-12' : 'col-sm-12 col-md-6'"
          >
            <iframe
              :src="link"
              width="100%"
              class="worksheets-iframe"
              @load="
                () => {
                  loading = false;
                }
              "
            ></iframe>
            <!-- <pdf :ref="`pdf${index}`" :src="link" class="worksheets-iframe" @page-loaded="loading = false"></pdf> -->
          </div>
        </template>
      </div>
    </el-dialog>
  </section>
</template>
<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
// import findByTextContent from './utils';

export default {
  data() {
    return {
      hostname: window.location.hostname,
      lesson: null,
      showCountDown: false,
      shadow: false,
      countdown: null,
      secondsDown: 0,
      setTimeout: null,
      dialogVisible: false,
      listUrlWorksheet: [],
      loading: false,
      isInactive: false,
      timeId: null,
      quizzInstrView: false,
      tracking: {
        id: null,
        userId: null,
        lessonId: null,
        quizPresented: null,
        quizScore: null,
        startedDate: null,
        endDate: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      currentLesson: 'lesson/currentLesson',
      subject: 'subject/currentSubject',
      lang: 'app/language',
      authenticatedUser: 'auth/authenticatedUser',
    }),
  },
  mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    clearInterval(this.timeId);
  },
  created() {
    // localStorage.setItem(this.$route.query.lesson_id, 0);
    // this.timeId = setInterval(() => {
    //   let value = localStorage.getItem(this.$route.query.lesson_id);
    //   !this.isInactive ? localStorage.setItem(this.$route.query.lesson_id, value++) : null;
    // }, 1000);
  },
  methods: {
    startTracking() {
      this.tracking.userId = this.authenticatedUser.id;
      this.tracking.lessonId = this.$route.params.lesson_id;
      this.tracking.startDate = moment().format();
    },
    endTracking() {
      this.tracking.endDate = moment().format();

      this.$httpMain
        .post('lesson-tracking', {
          user_id: Number.parseInt(this.tracking.userId),
          lesson_id: Number.parseInt(this.tracking.lessonId),
          start_date: this.tracking.startDate,
          end_date: this.tracking.endDate,
        })
        .then(res => {
          this.tracking.id = res.data;
        });
    },
    serveWorkSheet() {
      this.loading = true;
      this.listUrlWorksheet = [];
      this.dialogVisible = true;
      let files = [
        { name: this.currentLesson.id + '.pdf' },
        { name: this.currentLesson.id + '_1.pdf' },
        { name: this.currentLesson.id + '_2.pdf' },
      ];
      files.forEach(file => {
        let imageUrl = 'https://' + this.hostname + '/static/worHud98Km/' + file.name;
        var http = new XMLHttpRequest();
        http.open('HEAD', imageUrl, false);
        http.send();
        if (http.status != 404) {
          this.listUrlWorksheet.push(imageUrl);
        }
      });

      // en caso de que no exiatan worksheets
      this.listUrlWorksheet.length ? null : (this.loading = false);
    },
    exitLesson() {
      var vm = this;
      vm.quizzInstrView = true;
      vm.$router.push({ name: 'subject', query: { cluster_id: vm.$route.params.cluster_id } });
    },
    handleClose() {
      this.dialogVisible = false;
    },
    skip() {
      // clearTimeout(this.setTimeout);
      // Se desabilita el countDown
      // this.showCountDown = false;
      // para evitar que la vista quizzInstructions se duplique
      if (this.$route.params.grade_id != 5 && this.$route.params.grade_id != 2 && this.subject.can_make_quiz) {
        this.$router.push({ name: 'quizInstructions', query: { t: this.tracking.id } });
        this.quizzInstrView = true;
      } else {
        this.$router.push({ name: 'subject', query: { cluster_id: this.$route.params.cluster_id } });
      }
      this.shadow = false;
    },
    handleResize() {
      this.$refs.lesson.style.height = window.innerHeight - this.$refs.lesson.getBoundingClientRect().top + 'px';
    },
    onLoad() {
      this.startTracking();
      localStorage.setItem('startedDate', moment().format());
      this.lesson = window.document.getElementById('captivate');
      var interfaceObj;
      var eventEmitterObj;
      var vm = this;

      //FIXME solucionar las lecciones que no actualizan su state_id despues de terminar la leccion (no se redirige automáticamente al cluster cuando se terminan)
      // if (
      //   vm.currentLesson.id == 2263 ||
      //   vm.currentLesson.id == 2264 ||
      //   vm.currentLesson.id == 2265 ||
      //   vm.currentLesson.id == 2266 ||
      //   vm.currentLesson.id == 2267 ||
      //   vm.currentLesson.id == 2268 ||
      //   vm.currentLesson.id == 2235
      // ) {
      //   vm.saveProgress(3);
      // }
      this.lesson.contentWindow.addEventListener('moduleReadyEvent', function (evt) {
        interfaceObj = evt.Data;
        eventEmitterObj = interfaceObj.getEventEmitter();
        eventEmitterObj.addEventListener(
          'CPAPI_VARIABLEVALUECHANGED',

          function () {
            // guardar estado 3 cuando es leccion de preschool o kinder
            if (vm.$route.params.grade_id != 5 && vm.$route.params.grade_id != 2) {
              vm.saveProgress(2);
            } else {
              vm.saveProgress(3);
            }
            vm.endTracking();
            // Oculta el boton Back de la lesson
            // Array.from(vm.lesson.contentWindow.document.getElementsByClassName('cp-rewrap')).map(
            //   element => {
            //     element.style.visibility = 'hidden';
            //   },
            // );
            // Array.from(vm.lesson.contentWindow.document.getElementsByClassName('cp-frameset')).map(
            //   element => {
            //     element.style.visibility = 'hidden';
            //   },
            // );
            // vm.slide.contentWindow.cpAPIInterface.setVolume(100);
            // if (vm.$route.params.grade !== 'preschool' && vm.$route.params.grade !== 'transitional-kinder') {
            //   Array.from(vm.slide.contentWindow.document.getElementsByClassName('cp-shape')).map(element => {
            //     element.style.visibility = 'hidden';
            //   });
            //   // Activa el div .shadow
            //   setTimeout(() => {
            //     vm.shadow = true;
            //   }, 500);
            // Se inicia countDownSeconds
            // if (vm.settingsFromVuex.status) {
            // if (vm.$route.params.grade_id != 5 && vm.$route.params.grade_id != 2) {
            // vm.countDownSeconds(5);
            if (
              vm.currentLesson.id != 2258 &&
              vm.currentLesson.id != 2257 &&
              vm.currentLesson.id != 2259 &&
              vm.currentLesson.id != 2260 &&
              vm.currentLesson.id != 2261 &&
              vm.currentLesson.id != 2256 &&
              vm.currentLesson.id != 2262
            )
              vm.shadow = true;
            // }
            /* vm.setTimeout = setTimeout(() => {
              // Se oculta el div .shadow
              vm.shadow = false;
              if (vm.$route.params.grade_id != 5 && vm.$route.params.grade_id != 2 && vm.subject.can_make_quiz) {
                // Evita que se vuelva a ejecutar el redireccinamiento.
                vm.setTimeout = null;
                // para evitar que la vista quizzInstructions se duplique
                if (vm.quizzInstrView === false) {
                  vm.$router.push({ name: 'quizInstructions', query: { t: vm.tracking.id } });
                }
              }
              //FIXME reportar al departamento de diseño sobre las siguientes lecciones que la variable 'isLessonEnded' no se ejecuta al final de lección si no antes, y esto provoca que te saque de la lección sin antes terminarla.
              else {
                if (
                  vm.currentLesson.id != 2258 &&
                  vm.currentLesson.id != 2257 &&
                  vm.currentLesson.id != 2259 &&
                  vm.currentLesson.id != 2260 &&
                  vm.currentLesson.id != 2261 &&
                  vm.currentLesson.id != 2256 &&
                  vm.currentLesson.id != 2262
                ) {
                  // console.log('lecciones que no ejecutan lesson neded y salen de lesson');
                  vm.$router.push({ name: 'subject', query: { cluster_id: vm.$route.params.cluster_id } });
                }
              }
            }, 5000); */
            // }
            // }
            // // console.log(vm.settingsFromVuex.status === status, 'showBtnPretest')
            // if (!vm.settingsFromVuex.status) {
            //   // Notifica que la lesson fue terminada
            //   vm.saveProgress(3);
            //   /** Determina el valor del progreso de la lesson como terminada */
            //   var payload = {
            //     state_id: 3,
            //     lesson: vm.$route.params.lesson,
            //   };
            //   /** Guarda el progreso de la lesson en el array $store.state.currentGrade */
            //   vm.$store.dispatch('saveProgressInLessonSelected', payload);
            //   vm.backFn();
            // }
            // Se termina de crear el modelo que representa la actividad del alumno con la lesson
            // vm.lessonInfo.end = new Date();
            // vm.$store.commit('ADD_LESSON_TO_LESSONSLEARNED', vm.lessonInfo);
            // vm.statusChronometer = false;
            // alert('Lesson ended')
          },

          'isLessonEnded',
        );
      });
    },
    //  progress.LessonID, progress.UserID, progress.CurrentSlide, progress.StateID, progress.ClusterID, progress.IsLocked, progress.ID
    saveProgress(stateID) {
      this.$httpMain
        .post(`save_lesson_progress`, {
          lesson_id: this.currentLesson.id,
          user_id: this.authenticatedUser.id,
          state_id: stateID,
        })
        .then(res => {
          this.lessonProgress = res.data;
        });
    },
    countDownSeconds(seconds) {
      this.secondsDown = seconds;
      // Muestra el contador inverso de segundos en el template
      this.showCountDown = true;
      // Se crea un intervalo para descontar 1 cada segundo en this.secondsDown
      this.countdown = setInterval(() => {
        this.secondsDown -= 1;
        // Si this.secondsDown llega a 0 el setInterval es eliminado
        if (this.secondsDown === 0) {
          clearInterval(this.countdown);
          // Oculta el contador inverso en el template
          this.showCountDown = false;
        }
      }, 1000);
    },
  },
};
</script>
<style lang="scss" scoped>
.screen{
  margin-left: -15px;
  margin-right: -15px;
  overflow-y: auto;
  position: relative;
}
.lesson{
  width: 100%;
  height: 85vh;
  }

.count-down{
  position: absolute;
  left: 10px;
  right: 10px;
  width: 150px;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #6c757d;
  border-radius: 5px;
  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.4);
  .seconds{
    color: #fff;
    font-size: 70px;
    user-select: none;
  }
}
.pretest-ready .btn-done:focus{
  box-shadow: none;
  }

.shadow{
  position: absolute;
  left: 0;
  background-color: rgba(245, 244, 241, 0.01);
  z-index: 9;
  bottom: 0;
  right: 0;
  top: 35px;
  .btn{
    width: 150px;
    font-size: 20px;
    position: absolute;
    bottom: 20px;
    left: 150px;
    }
}
.worksheets-btn{
  position: absolute;
  top: 0;
  left: 2em;
  color: #fff;
  background-color: #E6A23C;
  transition: all .5s;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  &:hover{
    background-color: rgba(230, 162, 60, .8);
    border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em;
    }
  &:focus{
    box-shadow: none;
    border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em;
    }
    }
.exit-btn{
  background: transparent;
  position: absolute;
  //top: 2.5em
  right: 0;
  img{
    width: 30px;
  }
  //color: #fff;
  //background-color: #ff0e0e;
 /* transition: all .5s;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  &:hover{
    background-color: #ec4747;
    border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em;
    }
  &:focus{
    box-shadow: none;
    border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em;
    }*/
}
.worksheets-iframe{
  min-height: 75vh;
}

@media (max-width: 576px){
  .exit-btn{
    position: fixed;
    font-size: 10pt;
    width: 94px;
    left: 10em;
    }
  .worksheets-btn{
    z-index: 999;
    font-size: 10pt;
    }
  .shadow{
    z-index: 9;
    .btn{
      font-size: 10pt;
      width: 100px;
      position: fixed;
      }
    }

}

@media (max-width: 992px){
  .exit-btn{
    position: fixed;
    font-size: 13pt;}
  .worksheets-btn{
    z-index: 999;
    font-size: 13pt;}
}
// landscape
@media (max-height: 500px){
  .exit-btn{
    position: fixed;
    font-size: 10pt;
    //left: 10em;
    left: 2em;
    top: 6em;
    width: 94px;

  }
  .worksheets-btn{
    z-index: 999;
    font-size: 10pt;
  }

  .shadow .btn{
      font-size: 10pt;
      width: 100px;
      }
}
</style>
